import md5 from "md5";
import { useCallback, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logAppsflyerAction } from "../../../../app/appActions";
import { LOG_AF_EVENT_NAMES } from "../../../../app/appConstants";
import { getUserSelectedAccountCode, getUserSelectedAccountType } from "../../../../app/appSelectors";
import parseAccountName from "../../../../utils/parseAccountName";
import { shadowString } from "../../../../utils/shadowUtils";

const CLOSE_SELECT_SOURCE = {
    ACCOUNT_ITEM: 'account_item',
    BACK: 'back',
    OUTSIDE: 'outside',
}

export const useLiteTradeSelectAccountAppsflyerEvents = () => {
    const isSliderOpen = useRef(false);
    const selectedAccountType = useSelector(getUserSelectedAccountType);
    const selectedAccountCode = useSelector(getUserSelectedAccountCode);
    const dispatch = useDispatch();

    const handleCloseAccountSelectAppsflyer = useCallback(({oldValue, newValue, source}) => {
        dispatch(logAppsflyerAction({
            name: LOG_AF_EVENT_NAMES.MAIN_SELECT_ACCOUNT,
            payload: {
                account_type: selectedAccountType,
                old_value: shadowString(oldValue, 'md5'),
                new_value: shadowString(newValue, 'md5'),
                source,
            }
        }));
    }, [dispatch, selectedAccountType]);

    useEffect(() => () => {
        if (isSliderOpen.current) {
            handleCloseAccountSelectAppsflyer({
                oldValue: selectedAccountCode,
                newValue: selectedAccountCode,
                source: CLOSE_SELECT_SOURCE.BACK,
            })
        }
    }, [handleCloseAccountSelectAppsflyer, selectedAccountCode]);

    const handleAccountSelectAppsflyer = useCallback((accountCode) => {
        handleCloseAccountSelectAppsflyer({
            oldValue: selectedAccountCode,
            newValue: accountCode,
            source: CLOSE_SELECT_SOURCE.ACCOUNT_ITEM,
        })
        isSliderOpen.current = false;
    }, [handleCloseAccountSelectAppsflyer, selectedAccountCode]);

    const handleSelectToggleClickAppsflyer = useCallback(() => {
        dispatch(logAppsflyerAction({
            name: LOG_AF_EVENT_NAMES.MAIN_ACCOUNT_TYPE,
            payload: { account_type: parseAccountName(selectedAccountCode).type },
        }));
        isSliderOpen.current = true;
    }, [dispatch, selectedAccountCode]);

    const handleSelectAccountCancelAppsflyer = useCallback(() => {
        handleCloseAccountSelectAppsflyer({
            newValue: selectedAccountCode,
            oldValue: selectedAccountCode,
            source: CLOSE_SELECT_SOURCE.OUTSIDE,
        })
        isSliderOpen.current = false;
    }, [handleCloseAccountSelectAppsflyer, selectedAccountCode]);

    return {handleAccountSelectAppsflyer, handleSelectToggleClickAppsflyer, handleSelectAccountCancelAppsflyer}
}
